import { Button, Checkbox, DatePicker, Input } from "@arco-design/web-react";
import { RotateCcw, Search } from "lucide-react";

import type { FinanceReceivableOverviewFilters } from "../types";
import "../../../shared/ui/crmListPageLayout.css";
import "./financeOverview.css";

type Props = {
  filters: FinanceReceivableOverviewFilters;
  onChange: (filters: FinanceReceivableOverviewFilters) => void;
  onSearch: () => void;
  onReset: () => void;
};

/** 应收列表筛选区：搜索、出团日期范围（两端都含）、销售姓名、只看还有尚欠；点查询才生效。 */
export function FinanceReceivableOverviewFilterCard({ filters, onChange, onSearch, onReset }: Props) {
  return (
    <section className="crm-list-filter-panel" role="search" aria-label="应收列表筛选" data-layout="two-tier-responsive">
      <form
        className="crm-list-filter-fields"
        onSubmit={(event) => {
          event.preventDefault();
          onSearch();
        }}
      >
        <div className="crm-list-filter-primary">
          <label className="crm-list-field crm-list-field--lg">
            <span>搜索</span>
            <Input
              value={filters.keyword}
              placeholder="团编码、订单号、线路、客户"
              allowClear
              onPressEnter={onSearch}
              onChange={(keyword) => onChange({ ...filters, keyword })}
            />
          </label>
          <div className="crm-list-field crm-list-field--lg">
            <span>出团日期</span>
            <DatePicker.RangePicker
              className="finance-overview-date-range"
              placeholder={["出团开始日期", "出团结束日期"]}
              value={filters.departureFrom && filters.departureTo ? [filters.departureFrom, filters.departureTo] : undefined}
              getPopupContainer={() => document.body}
              onChange={(dates) =>
                onChange({ ...filters, departureFrom: dates?.[0] || null, departureTo: dates?.[1] || null })
              }
            />
          </div>
          <label className="crm-list-field crm-list-field--md">
            <span>销售</span>
            <Input
              value={filters.salesName}
              placeholder="销售姓名"
              allowClear
              onPressEnter={onSearch}
              onChange={(salesName) => onChange({ ...filters, salesName })}
            />
          </label>
          <div className="crm-list-field crm-list-field--md">
            <span>尚欠</span>
            <Checkbox
              className="finance-overview-check"
              checked={filters.hasOutstanding}
              onChange={(hasOutstanding: boolean) => onChange({ ...filters, hasOutstanding })}
            >
              只看还有尚欠
            </Checkbox>
          </div>
        </div>
      </form>
      <div className="crm-list-filter-actions">
        <Button icon={<RotateCcw size={16} />} onClick={onReset}>
          重置
        </Button>
        <Button type="primary" icon={<Search size={16} />} onClick={onSearch}>
          查询
        </Button>
      </div>
    </section>
  );
}
